/** CSV export helper.
 *
 * Prepends a metadata block (context + timestamp) to each export so downstream
 * reviewers know exactly what filter produced the file.
 */
export function downloadCsv(filename, rows, { context = {}, timestampField = "generated_at" } = {}) {
  const timestamp = new Date().toISOString();
  const meta = { ...context, [timestampField]: timestamp };
  const metaLines = Object.entries(meta).map(([k, v]) => `# ${k}: ${typeof v === "object" ? JSON.stringify(v) : v}`);
  if (!rows?.length) {
    _download(filename, [...metaLines, "# no rows"].join("\n"));
    return;
  }
  const cols = Object.keys(rows[0]);
  const escape = (v) => {
    if (v == null) return "";
    const s = String(v);
    return s.includes(",") || s.includes('"') || s.includes("\n") ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const body = [cols.join(","), ...rows.map((r) => cols.map((c) => escape(r[c])).join(","))];
  _download(filename, [...metaLines, ...body].join("\n"));
}

function _download(filename, text) {
  const blob = new Blob([text], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = filename;
  document.body.appendChild(a); a.click();
  setTimeout(() => { URL.revokeObjectURL(url); a.remove(); }, 100);
}
